var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"10","y1":"15","x2":"60","y2":"50","strokeWidth":"6","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"10","y1":"85","x2":"60","y2":"50","strokeWidth":"6","strokeLinecap":"round","key":1})]);
}

ArrowRightIcon.defaultProps = {"className":"arrow-right","aria-label":"next","role":"img","viewBox":"0 0 61 100","height":"100","width":"61"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
